// Creates a cropped image File from a rendered <img> element and a pixel crop.
/**
 * @param {HTMLImageElement} image - the rendered image element
 * @param {object} pixelCrop - { x, y, width, height } from react-image-crop's
 *        completed crop, in *displayed* pixels relative to the element
 * @param {string} fileName - desired output file name
 * @param {string} mimeType - output mime type (defaults to image/jpeg)
 * @returns {Promise<File>} cropped image as a File
 */
export const getCroppedImg = async (
  image,
  pixelCrop,
  fileName = "cropped.jpg",
  mimeType = "image/jpeg"
) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  // The element may be displayed smaller/larger than the source image.
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  canvas.width = Math.round(pixelCrop.width * scaleX);
  canvas.height = Math.round(pixelCrop.height * scaleY);

  ctx.drawImage(
    image,
    pixelCrop.x * scaleX,
    pixelCrop.y * scaleY,
    pixelCrop.width * scaleX,
    pixelCrop.height * scaleY,
    0,
    0,
    canvas.width,
    canvas.height
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Canvas is empty"));
          return;
        }
        const safeName = fileName.replace(/\.[^/.]+$/, "") + ".jpg";
        const croppedFile = new File([blob], safeName, { type: mimeType });
        resolve(croppedFile);
      },
      mimeType,
      0.92
    );
  });
};
